export const initialRoles = {
  id: '',
  name: '',
  description: '',
  tokens: [],
};
